__turbopack_context__.v({
  "default": "badge-module__NmXYra__default",
  "destructive": "badge-module__NmXYra__destructive",
  "outline": "badge-module__NmXYra__outline",
  "root": "badge-module__NmXYra__root",
  "secondary": "badge-module__NmXYra__secondary",
});
